import React, { useState, useEffect } from "react";
import {
  commonHeaderStyle,
  commonStyle,
  displayNullFormatter,
  getMonthName,
  rowStyle2,
} from "../Utility/utility";
import moment from "moment";
import "../style.css";
import "./style.css";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector } from "react-redux";
import NoData from "../Utility/NoData";
import ReactPaginate from "react-paginate";
import ErrorModal from "./ErrorModal";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import { setSelected, setSelectedUnique } from "./action";

const HistoryTable = ({ handlePageClickHistory }) => {
  const dispatch = useDispatch();
  const [openError, setOpenError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const { historyTableData, totalPagesHistory, selected, selectUnique } =
    useSelector((state) => state.gstr2a2bNewFetchReducer);

  const handleErrorMsgFetch = (row) => {
    console.log("handleErrorMsgFetch called row.ERROR_MSG:", row);
    setErrorMsg(
      row?.ERROR_MSG || "Error while fetching from government portal"
    );
    setOpenError(true);
  };

  const historyColumns = [
    {
      dataField: "GSTIN",
      text: "GSTIN",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "15%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "GSTIN"),
    },
    {
      dataField: "RET_PERIOD",
      text: "Period",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "15%",
      },
      formatter: (cell, row) => {
        return <>{row.RET_PERIOD ? getMonthName(row.RET_PERIOD) : "--"}</>;
      },
    },

    {
      dataField: "FISCAL_YEAR",
      text: "Financial Year",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "12%",
      },
      formatter: (cell, row) => displayNullFormatter(row, "FISCAL_YEAR"),
    },
    {
      dataField: "FETCH_TYPE",
      text: "Report Type",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "12%",
      },

      formatter: (cell, row) => displayNullFormatter(row, "FETCH_TYPE"),
    },
    {
      dataField: "STATUS",
      text: "Fetch Status",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "15%",
      },
      formatter: (cell, row) => {
        return (
          <>
            <div
              className="circle-div"
              style={{
                cursor:
                  row?.STATUS?.toUpperCase() === "FAILED"
                    ? "pointer"
                    : "default",
              }}
            >
              {row?.STATUS?.toUpperCase() === "FAILED" && (
                <ErrorOutlineIcon
                  style={{ height: "16px", verticalAlign: "top" }}
                  onClick={() => handleErrorMsgFetch(row)}
                />
              )}
              {row?.STATUS === null ? "In-Progress" : row?.STATUS}
              <div
                className="circle-span"
                style={{
                  marginTop: "2px",
                  marginLeft: "2px",
                  cursor:
                    row?.STATUS?.toUpperCase() === "FAILED"
                      ? "pointer"
                      : "default",
                  backgroundColor:
                    row?.STATUS?.toUpperCase() === "COMPLETED"
                      ? "#9BD732"
                      : row?.STATUS === null
                      ? "#FFC23D"
                      : row?.STATUS?.toUpperCase() === "FAILED"
                      ? "#FF5149"
                      : "#CCC4BD",

                  // row?.gstn_session_status == "1" ? "green" : "red",
                  // #9BD732,
                  // " #FF5149"
                  // #CCC4BD:grey
                  // #FFC23D:yellow
                }}
              ></div>
            </div>
          </>
        );
      },
    },
    {
      dataField: "CREATED_DATE",
      text: "Fetch Date & Time",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "15%",
      },
      formatter: (col, row) => {
        return (
          <>
            {row?.CREATED_DATE
              ? moment
                  .parseZone(row?.CREATED_DATE)
                  .format("DD/MM/YYYY HH:mm:ss")
              : "--"}
          </>
        );
      },
    },

    {
      dataField: "GSTIN_STATUS",
      text: "GSTN Session Status",
      style: (cell, row, rowIndex, colIndex) => ({
        ...commonStyle,
      }),
      headerStyle: {
        ...commonHeaderStyle,
        width: "16%",
      },
      formatter: (cell, row) => {
        return (
          <>
            <div className="circle-div">
              <span
                className="circle-span"
                style={{
                  backgroundColor:
                    row?.GSTIN_STATUS?.toUpperCase() === "ACTIVE"
                      ? "#9BD732"
                      : "#FF5149",

                  // #FF5149:red
                  // #CCC4BD:grey
                  // #FFC23D:yellow
                }}
              ></span>
            </div>
          </>
        );
      },
    },
  ];

  const selectRow = {
    mode: "checkbox",
    selected: selectUnique,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
    headerColumnStyle: {
      width: "1%",
      verticalAlign: "text-top",
    },
    selectColumnStyle: {
      width: "1%",
      textAlign: "center",
    },

    nonSelectable: historyTableData
      ?.filter((r) => r.STATUS?.toUpperCase() !== "COMPLETED")
      .map((r) => r.ID),
  };

  // function handleOnSelect(row, isSelect) {

  //   if (isSelect) {
  //   dispatch(setSelectedUnique([...selectUnique, row.ID]));
  //     dispatch(setSelected([...selected, row]))
  //   } else {
  //     let selectedValue = [...selected];
  //     selectedValue.splice(selectedValue.indexOf(row.ID), 1);
  //     dispatch(setSelectedUnique(selectedValue));
  //     dispatch(setSelected(selected.filter(x => x.ID!== row.ID)));
  //   }
  // }
  function handleOnSelect(row, isSelect) {
    if (isSelect) {
      dispatch(setSelectedUnique([...selectUnique, row.ID]));
      dispatch(setSelected([...selected, row]));
    } else {
      const updatedMismatch = selectUnique.filter((id) => id !== row.ID);
      dispatch(setSelectedUnique(updatedMismatch));

      const updatedRows = selected.filter((r) => r.ID !== row.ID);
      dispatch(setSelected(updatedRows));
    }
  }

  function handleOnSelectAll(isSelect, rows) {
    const ids = rows.map((r) => r.ID);
    if (isSelect) {
      dispatch(setSelectedUnique(ids));
      dispatch(setSelected(rows));
    } else {
      dispatch(setSelected([]));
      dispatch(setSelectedUnique([]));
    }
  }

  // Clear selection on component unmount
  useEffect(() => {
    return () => {
      dispatch(setSelected([]));
      dispatch(setSelectedUnique([]));
    };
  }, []);


  return (
    <>
      {historyTableData?.length > 0 ? (
        <>
          <div
            style={{ marginTop: "1em" }}
            className="light-border-gstr2a2bnew-table"
          >
            <BootstrapTable
              keyField="ID"
              data={historyTableData}
              columns={historyColumns}
              rowStyle={rowStyle2}
              selectRow={selectRow}
            />
          </div>
          <br />
          <ReactPaginate
            previousLabel={"previous"}
            nextLabel={"next"}
            breakLabel={"..."}
            breakClassName={"break-me"}
            pageCount={totalPagesHistory}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClickHistory}
            containerClassName={"pagination"}
            subContainerClassName={"pages pagination"}
            activeClassName={"active"}
          />
          <ErrorModal
            openError={openError}
            setOpenError={setOpenError}
            errorMsg={errorMsg}
          />
        </>
      ) : (
        <NoData />
      )}
    </>
  );
};

export default HistoryTable;
